import { Mail, MapPin, MessageSquareMore, PhoneCall } from "lucide-react";

import { LeadActions } from "@/components/LeadActions";
import { QuoteForm } from "@/components/QuoteForm";
import { SectionHeading } from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";
import { contactDetails, productOptions } from "@/data/siteContent";

export default function ContactPage({ content }) {
  const isHindi = content.locale === "hi";
  const contactCards = [
    { id: "phone", icon: PhoneCall, label: isHindi ? "कॉल" : "Call", value: contactDetails.phoneDisplay, href: contactDetails.phoneLink },
    { id: "whatsapp", icon: MessageSquareMore, label: "WhatsApp", value: contactDetails.whatsappDisplay, href: contactDetails.whatsappLink },
    { id: "email", icon: Mail, label: isHindi ? "ईमेल" : "Email", value: contactDetails.email, href: contactDetails.emailLink },
    { id: "address", icon: MapPin, label: isHindi ? "पता" : "Address", value: contactDetails.address, href: null },
  ];

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <SectionHeading eyebrow={isHindi ? "संपर्क" : "Contact"} title={content.contactPage.title} description={content.contactPage.description} />
      <div className="mt-10 grid gap-6 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="grid gap-5">
          {contactCards.map((item) => {
            const Icon = item.icon;
            const body = (
              <Card className="rounded-[28px] border-stone-200 bg-white shadow-sm">
                <CardContent className="flex items-start gap-4 p-6">
                    <div className="rounded-2xl bg-primary/10 p-3 text-primary" data-testid={`contact-card-icon-${item.id}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.24em] text-stone-400" data-testid={`contact-card-label-${item.id}`}>
                      {item.label}
                    </p>
                    <p className="mt-2 text-sm font-medium leading-7 text-stone-700" data-testid={`contact-card-value-${item.id}`}>
                      {item.value}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );

            return item.href ? (
              <a key={item.label} href={item.href} target={item.id === "whatsapp" ? "_blank" : undefined} rel={item.id === "whatsapp" ? "noreferrer" : undefined} data-testid={`contact-card-link-${item.id}`}>
                {body}
              </a>
            ) : (
              <div key={item.label}>{body}</div>
            );
          })}

          <LeadActions labels={content.ctas} contact={contactDetails} prefix="contact-page" />
        </div>

        <div id="quote-request" className="grid gap-6">
          <QuoteForm copy={{ ...content.quoteForm, submitQuote: content.ctas.submitQuote, submitContact: content.ctas.submitContact }} products={productOptions} language={content.locale} mode="quote" />
          <QuoteForm copy={{ ...content.quoteForm, title: content.contactPage.title, description: content.contactPage.description, submitQuote: content.ctas.submitQuote, submitContact: content.ctas.submitContact }} products={productOptions} language={content.locale} mode="contact" />
        </div>
      </div>
    </div>
  );
}